module.exports = __webpack_public_path__ + "static/media/mc_hrz_rev_white.fb0efb16.svg";